import keycloakAxios from '@/services/axios';

export const fetchUserData = async (bDayAlt?: string) => {
  const response = await keycloakAxios.get('user/me');

  if (response.status >= 300) {
    throw new Error(
      `Error fetching user data: Invalid status code: ${response.status}`
    );
  }

  const data = response.data;

  const location =
    data.geolocation && data.geolocation.coordinates
      ? {
          lng: data.geolocation.coordinates[0],
          lat: data.geolocation.coordinates[1],
          label: data.hometown
        }
      : null;

  const newFormValues = {
    _id: data._id || '',
    name: data.name || '',
    birthday: data.birthday || bDayAlt,
    description: data.description || '',
    hometown: data.hometown || '',
    gender: data.gender || '',
    location: location,
    color: data.color || '',
    groups: data.groups || [],
    picture: data.picture || '',
    companies: data.companies || [],
    sports: data.sports || null,
    updatedAt: data.updatedAt || null,
    userBlacklist: data.userBlacklist || [],
    email: data.email || '',
    odooCompany: data.odooCompany || null
  };

  return newFormValues;
};
